export default "__VITE_ASSET__9Y1gQhLb__"